module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("xtwBA"))).then(() => parcelRequire('hEqeo'));